import { createSelector } from 'reselect';
import { RootState } from '../../../../config/store/rootReducer';
import { AlertWithIdentifier } from '../reducers/alerts';

const getAlerts = (state: RootState): AlertWithIdentifier[] => state.alerts;

export const makeGetAlerts = () => createSelector(getAlerts, (alerts: AlertWithIdentifier[]) => alerts);
